import React from 'react';

import * as S from './ThresholdArea.styles';

export type Variant = 'bullish' | 'bearish';

interface ThresholdAreaProps {
  variant?: Variant;
  offset?: number;
  height?: number;
  edgeOffset?: number;
  showEdgeLine?: boolean;
  width?: number;
}

export const ThresholdArea: React.FunctionComponent<ThresholdAreaProps> = ({
  variant = 'bullish',
  height,
  offset,
  edgeOffset = offset,
  showEdgeLine = true,
  width,
}) => {
  return (
    <g>
      <S.AreaRect
        data-testid="area-rect"
        width={width}
        y={offset}
        height={height}
        variant={variant}
        showEdgeLine={showEdgeLine}
      />
      {showEdgeLine && (
        <S.EdgeLine
          data-testid="edge-line"
          x1="0"
          y1={edgeOffset}
          x2={width}
          y2={edgeOffset}
          variant={variant}
        />
      )}
    </g>
  );
};
